export const convertDataToApi = (data) => {
  return { ...data, order: +data.order };
};
